<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>

        <div class="section imgone">
            <img :src="imageUrlone" alt="">
        </div>
        <div class=" containertow" ref="secondSection">
            <div v-for="(location, index) in locations" :key="index" class="location"  :class="{'first-location': index === 0}">
                <h2>{{ isEnglish ?location.titleen: location.title }}</h2>
                <!-- 地理位置描述，包含图标和文字 -->

                <p style="position: relative">
                    <img :src="location.icon" alt="定位图标"
                         style=" position:relative;top:-0.15rem;left:-1rem;width: auto; height: 1.5rem; vertical-align: middle;">
                         {{ isEnglish ?location.titleen:location.address }}
                </p>
                <!-- 图片展示区域 -->
                <div class="images">
                    <img v-for="(image, imgIndex) in location.images" :key="imgIndex" :src="image" alt="展示图片">
                </div>
            </div>
        </div>
<!--        <div class="section" >-->
<!--            <div class="ss">测试111111111111122222</div>-->
<!--        </div>-->
<!--        <div class="section">-->
<!--            另一个测0-->
<!--        </div>-->
        <!-- 添加更多 section -->
        <!-- <Bottom2></Bottom2> -->
        <Bottom style="margin-top: -3rem"></Bottom>
    </div>
</template>

<script>
        import Header from'@/view/public/heardpc.vue'
        import { mapActions, mapState } from 'vuex';
import Bottom from "@/view/public/bottompc.vue";
import axios from 'axios';
import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
    export default {

        components:{
        
            Header,
      
            Bottom
        },
        data() {
            return {
                isScrolled: false,
                imageUrlone: require('../../assets/showcenter-banner-05-06.png'),
                // 地点和图片、文案数据
                locations: [
                    {
                        titleen: "暂无英文",
                        title: "谱祺商旅品牌产品展示中心",
                        addressen:"暂无英文地址",
                        address: "中国·广州市南沙自贸区海滨路169号1楼",
                        icon: require('../../assets/pic-icon-18showcenter.png'),
                        images: [
                            require('../../assets/pic-PUKI exhibition center1.jpg'),
                            require('../../assets/pic-PUKI exhibition center2.jpg'),
                        ]
                    },
                    {
                        titleen: "暂无英文",
                        title: "谱祺商旅品牌产品旗舰工厂",
                          addressen:"暂无英文地址",
                        address: "中国·贵州省六盘水市水城经济开发区铝产业园",
                        icon: require('../../assets/pic-icon-18showcenter.png'),
                        images: [
                            require('../../assets/pic-GUIZHOU factory1.jpg'),
                            require('../../assets/pic-GUIZHOU factory2.jpg'),
                        ]
                    }
                ]

            };
        },
        computed: {
             // 从 Vuex 的 state 中获取 isEnglish 数据
             ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
             
        },

        mounted() {
            this.fetchData();
            window.addEventListener('wheel', this.handleScroll, { passive: false });
            this.$refs.boddy.addEventListener('scroll', this.debouncedHandleScroll);

            this.initObserver(); // 初始化观察器
        },
        beforeDestroy() {

            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {

            async fetchData() {
            try {
                // 发起 API 请求
                // const response = await axios.get('http://192.168.0.69:8083/website/api/getshowcenter');
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/getshowcenter`);
                const data = response.data;
                // console.log(data)
                if (data && data.length > 0) {
                    // 处理 banner 图片
                    this.imageUrlone = `${apiUrls.devApi}${data[0].imageUrlone}`;

                    // 处理 locations 数据
                    this.locations = data.map(location => {
                        const imageArr = location.images.split(',').map(img => `${apiUrls.devApi}${img.trim()}`);

                        return {
                            titleen: location.titleen,
                            title: location.title,
                            addressen: location.addressen,
                            address: location.address.replace('&nbsp;', ' '), // 替换 HTML 中的空格
                            icon: `${apiUrls.devApi}${location.icon}`,
                            images: imageArr,
                        };
                    });
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        },
            initObserver() {
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
// 只观察第二个 section
                // 只观察第二个 section
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.isScrolled = true; // 当第二个 section 进入视口时设置 isScrolled = true
                        }
                    });
                }, options);
                const secondSection = this.$refs.secondSection; // 监视第二个 section
                if (secondSection) {
                    observer.observe(secondSection);
                }

            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }

                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                    height = window.innerHeight;
                    if(this.scrollCount==0){
                        scrollContainer.scrollBy({


                            top: event.deltaY > 0 ? height*1.05 : -height*1.05,
                            behavior: 'smooth'
                        });
                    }else {
                        scrollContainer.scrollBy({


                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });
                    }



                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                    setTimeout(() => {
                        // 先移除 fadeIn 类，强制重绘
                        const contents = scrollContainer.querySelectorAll('.content');
                        contents.forEach(content => {
                            content.classList.remove('fadeIn'); // 先移除
                            void content.offsetWidth; // 强制重绘
                        });

                        // 重新添加 fadeIn 类到当前可见的 .content
                        // this.checkVisibleSections(); // 检查可见的 sections

                        // 第一次滚动时，立即添加动画
                        if (this.scrollCount === 0) {
                            contents.forEach(content => {
                                content.classList.add('fadeIn'); // 立即添加动画类
                            });
                        }
                    }, 100); // 调整延迟时间以确保 DOM 更新后再执行




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>
/*    第二个模块开始*/
.containertow {
    background-color: white;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding-top: 5vh;


}
/* 地理位置部分的样式，包括标题和描述文本 */
.location {
    height: 97vh;
    display: flex; /* 使用 flexbox 布局 */
    flex-direction: column; /* 垂直方向排列子元素 */
    /*justify-content: center; !* 垂直居中 *!*/
    /*margin-top: 7rem;*/
    margin-top: 3vh;

}
.first-location {
    /*margin-top: -3rem; !* 只有第一个 location 元素有 -3rem 的 margin-top *!*/
}

/* 地理位置标题样式 */
.location h2 {margin-top: 6rem;
    font-size: 1.5rem; /* 调整为稍大的字体 */
    font-weight: 580; /* 设置字体粗细，600 是较粗的字体 */
    margin-bottom: 1rem; /* 适当增加下方间距 */
    color: #626161; /* 使用深灰色，适合现代设计 */

    letter-spacing: 0.05rem; /* 增加字间距，使标题更易读 */
}

/* 地理位置描述文本样式 */
.location p {
    font-size: 1.1rem;
    color: gray;
}

/* 图片展示区样式：通过 flex 布局让图片水平排列，并保持一定的间距 */
.images {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    gap: 2rem; /* 图片之间的间距 */
}

/* 图片样式：设置图片大小，剪裁方式，圆角效果以及阴影效果 */
.images img {
    width: 30rem;
    height: auto;
    object-fit: cover; /* 确保图片填满容器，同时保持图片比例 */
    border-radius: 0.2rem; /* 图片圆角 */
    /*box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); !* 图片的阴影效果 *!*/
}
    /*第二个模块结束*/
    /*    第一个模块图片开始*/
    .imgone img{
        width: 100%;
        height: auto;
        margin-bottom: 6vh;
    }
    /*    第一个模块图片结束*/
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
/*整体布局开始*/
.boddy {
height: 100vh;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 97vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {
    .location h2{
        margin-top: 0;
        margin: 0;
    }
    .images img{
        height: 8rem;
    }
    .location{
        height: 23vh;
        margin-top: 0!important;
        padding-top: 6vh;
    }
    .location p{
        margin: 0;
        font-size: 1rem;
    }
    .section{
        height: auto;
    }
    .imgone img{
        width: 100%;
        height: auto;
        margin-bottom: 0;
    }
    .titlehed{
        display: block!important;
        height: 10rem!important;
    }
    .containertow{
        padding-top: 0;
    }

}
/*手机端样式结束*/
</style>
